var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import Link from '../Link/Link';
import { getLinkProps } from '../Link/Link.functions';
import { FIRST_CONTENT_LEVEL_CLASS_NAME, SECOND_CONTENT_LEVEL_CLASS_NAME } from './Navigation.const';
import { updateIndexes } from './Navigation.functions';
import './Navigation.scss';
/**
 * Navigation component
 */
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    /**
     * Menu contructor
     *
     * @param props
     */
    function Navigation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.hideSubMenu = function () {
            var _a;
            _this.setState((_a = {},
                _a[FIRST_CONTENT_LEVEL_CLASS_NAME] = undefined,
                _a[SECOND_CONTENT_LEVEL_CLASS_NAME] = undefined,
                _a));
        };
        _this.onOver = _this.onOver.bind(_this);
        return _this;
    }
    /**
     * Apply effect on Link
     *
     * @public
     * @param element
     * @param index
     */
    Navigation.prototype.onOver = function (element, index) {
        this.setState(updateIndexes(element.props.className, index));
    };
    /**
     * Menu render method
     */
    Navigation.prototype.render = function () {
        var _this = this;
        var _a = this.props, categories = _a.categories, mobileMenuIsOpen = _a.mobileMenuIsOpen;
        var activeIndex = this.state[FIRST_CONTENT_LEVEL_CLASS_NAME];
        var activeSubIndex = this.state[SECOND_CONTENT_LEVEL_CLASS_NAME];
        return (React.createElement("div", { id: "navigation", className: mobileMenuIsOpen ? 'isOpen' : undefined },
            React.createElement("nav", null,
                React.createElement("ul", { className: "list-level-2 glxy-container" },
                    React.createElement("li", { className: "glxy-btn-home row-level-2" },
                        React.createElement(LinkRouter, { to: "/" },
                            React.createElement("i", { className: "home-icon icon" }))),
                    categories.map(function (row, index) { return (React.createElement(Link, __assign({ key: "" + row.url + index }, getLinkProps(row, index, _this.onOver, activeIndex, activeSubIndex), { onClickAction: _this.hideSubMenu }))); })))));
    };
    return Navigation;
}(React.Component));
export default Navigation;
//# sourceMappingURL=Navigation.js.map